var vertical_embed_viewer_default = {
  "card": "NynPg",
  "slimLayout": "cYaun",
  "cardLayout": "_7Or5F",
  "imageContainer": "hWyhh",
  "image": "LYDUP",
  "content": "mDFp8"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
